<script>
  import { fly } from "svelte/transition";
  import Button from "./Button.svelte";
  import { submitDistance } from "./utils";
  import { options } from "./constants";
  export let distanceOptionIdx;
  export let previous;
  export let next;
  export let userDistanceKey;

  let option = options[distanceOptionIdx];

  const nextHandler = async () => {
    await submitDistance(option.value, userDistanceKey);
    next();
  };
</script>

<style>
  p {
    margin: 0;
  }

  .label {
    font-weight: bold;
    font-size: 1.75rem;
  }

  .description {
    font-weight: bold;
    font-size: 1rem;
  }

  .buttons {
    margin: 2rem 2rem 0;
    display: grid;
    row-gap: 1rem;
    column-gap: 1rem;
    grid-template-rows: 1fr 1fr;
  }

  @media screen and (min-width: 640px) {
    .label {
      font-size: 2.25rem;
    }

    .description {
      font-size: 1.5rem;
    }

    .buttons {
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: initial;
    }

    .buttons *:nth-of-type(2) {
      grid-column: span 2;
    }
  }
</style>

<div class="wrapper" in:fly={{ x: 200, duration: 200 }}>
  <p class="label">
    <b>{option.confirmation}</b>
  </p>
  <p class="description">
    <b>{option.description}</b>
  </p>
  <div class="buttons">
    <div>
      <Button on:click={previous} outline={true} style="width: 100%;">
        TILLBAKA
      </Button>
    </div>
    <div>
      <Button on:click={nextHandler} style="width: 100%;">
        JA, JAG GÅR MED
      </Button>
    </div>
  </div>
</div>
